
import BaseTable, {AutoResizer, SortOrder} from 'react-base-table'
import React, {useEffect, useState} from 'react';
import 'react-base-table/styles.css'
import './base-table.css'
import styled from 'styled-components';

//NSN Sample Options
//5945007525599
//5945009027323

const CageTable = ({cageData}) => {
    
    const [data, setData] = useState({});

    const getAddress = (doc) => {
        const addressArray = [doc.street_address_1, doc.street_address_2, doc.city, doc.state, doc.zip, doc.country];
        const address = addressArray.join(' ');
        return address;
    }

    useEffect(() => {
        setData(cageData.map((doc) => {
            return {
                companyName: doc.company_name,
                address: getAddress(doc),
                status: doc.status,
                lastUpdate: doc.last_update,
                dateEstablished: doc.date_est
            }
        }));
    }, [cageData])

    const columns = [
        {
            key: 'companyName',
            dataKey: 'companyName',
            title: 'Company Name',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },
        
        {
            key: 'address',
            dataKey: 'address',
            title: 'Address',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },
         {
            key: 'status',
            dataKey: 'status',
            title: 'Status',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },
        {
            key: 'lastUpdate',
            dataKey: 'lastUpdate',
            title: 'Last Update',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },
         {
            key: 'dateEstablished',
            dataKey: 'dateEstablished',
            title: 'Date Established',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        }
    ]

    const Container = styled.div`
        width: calc(50vw + 220px);
        height: 50vh;
        `

    return (
    <>
        <Container>
            <AutoResizer>
                {({ width, height }) => (
                    <BaseTable
                        className='base-table'
                        width={width}
                        height={height}
                        columns={columns}
                        data={data}
                    />
                )}
            </AutoResizer>
        </Container>
    </>
    );
}

export default CageTable